export enum PickerPeriod {
  FROM,
  TO,
}
